type SharePayload = {
  title: string;
  description: string;
  link: string;
  image: string;
};

type WeChatSDK = {
  ready?: (callback: () => void) => void;
  updateAppMessageShareData?: (payload: {
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
    success?: () => void;
  }) => void;
  updateTimelineShareData?: (payload: {
    title: string;
    link: string;
    imgUrl: string;
    success?: () => void;
  }) => void;
};

declare global {
  interface Window {
    wx?: WeChatSDK;
  }
}

function setMeta(selector: string, attribute: 'content' | 'href', value: string) {
  const element = document.querySelector<HTMLMetaElement | HTMLLinkElement>(selector);
  if (element) element.setAttribute(attribute, value);
}

/**
 * Keep normal link previews useful everywhere and use the WeChat bridge when
 * the host has loaded/configured the JSSDK. The bridge is optional so a
 * missing JSSDK signature never interrupts browsing or answering.
 */
export function updateWechatShare(payload: SharePayload) {
  if (typeof window === 'undefined') return;
  setMeta('meta[property="og:title"]', 'content', payload.title);
  setMeta('meta[property="og:description"]', 'content', payload.description);
  setMeta('meta[property="og:url"]', 'content', payload.link);
  setMeta('meta[property="og:image"]', 'content', payload.image);
  const sdk = window.wx;
  if (!sdk) return;
  const apply = () => {
    try {
      sdk.updateAppMessageShareData?.({
        title: payload.title,
        desc: payload.description,
        link: payload.link,
        imgUrl: payload.image,
      });
      sdk.updateTimelineShareData?.({
        title: payload.title,
        link: payload.link,
        imgUrl: payload.image,
      });
    } catch {
      // Sharing must never block the learning flow.
    }
  };
  try {
    if (sdk.ready) sdk.ready(apply);
    else apply();
  } catch {
    // An unavailable or unconfigured bridge must not interrupt browsing.
  }
}
